// Chapter 2 story events (the quake night).
export const CH2_MORNING = {
  id: "hallway:event:ch2morning", room: "hallway", title: "Dana's Orders",
  text: "Dana told Joe to clear the panels and walk North Ridge. Institute said continue our duties.",
  lines: [
    { text: "Morning. Grey light. Joe's head is pounding, and he barely drank last night." },
    { who: "Dana", text: "Morning, sunshine. The institute said continue our duties, so... we continue our duties." },
    { who: "Dana", text: "Panels are buried again. Clear them, then take North Ridge. Sarah and I have the creek. Stephen's checking on the cars." },
    { who: "Joe", text: "And if the guy in the red robe is out there?" },
    { who: "Dana", text: "Then you walk faster." },
    { text: "She tries to smile. It doesn't quite work." },
  ],
};

export const QUAKE = {
  id: "trail_north:event:quake", room: "trail_north", title: "The Earthquake",
  text: "Joe drank too much on the trail and passed out. An earthquake woke him. It was night, and the station was never reset.",
  lines: [
    { text: "It's night. Hours have passed. Joe can barely feel his hands." },
    { text: "Somewhere far off, rocks are still sliding. The shaking has stopped, but the mountain is groaning." },
    { who: "Joe", text: "The station... I never reset the station." },
    { text: "No time. He has to get back to the cabin. Now." },
  ],
};

export const WAITING = {
  id: "living:event:waiting", room: "living", title: "They Waited Up",
  text: "Sarah said they were just about to come looking for Joe. Everyone felt the earthquake. Tomorrow we dig the cars out and leave.",
  lines: [
    { text: "The cabin door bangs open. Joe staggers in, covered in snow. All three of them are by the fire." },
    { who: "Sarah", text: "Joe! Oh, thank God. We were just about to come looking for you." },
    { who: "Dana", text: "Where were you? It's been dark for hours." },
    { who: "Joe", text: "I sat down. On the trail. I must have... passed out." },
    { text: "Nobody says the word 'drunk'. Everybody thinks it." },
    { who: "Stephen", text: "Did you feel the earthquake? The whole cabin jumped. Half the dishes are on the kitchen floor." },
    { who: "Sarah", text: "There aren't supposed to be earthquakes up here. Not like that." },
    { who: "Dana", text: "I'm done. Tomorrow we dig the cars out and we leave. Institute or no institute." },
    { who: "Stephen", text: "Agreed. First light, we start digging." },
    { text: "Then, three slow knocks on the front door." },
  ],
};

export const KNOCK = {
  id: "living:event:knock", room: "living", title: "Samantha",
  text: "Samantha, from the institute (and the cult), came with her kids Sam and Chloe. The stations are part of a 30-year ritual. Joe broke it. A key at the bottom of the cave opens the sealed basement door.",
  lines: [
    { text: "Stephen opens the door. A woman stands in the snow, holding the hands of two small children." },
    { who: "Samantha", text: "My name is Samantha. This is Sam. And this is Chloe." },
    { who: "Chloe", text: "Hi. Your porch light is flickering. That's a bad sign, you know." },
    { who: "Samantha", text: "Look. Normally I'd make up some story about being lost. But I'm from the institute, and you guys really messed up." },
    { who: "Samantha", text: "One of the research stations wasn't reset." },
    { text: "Every head in the room turns to Joe." },
    { who: "Samantha", text: "Normally I'd pretend I'm not one of the people in red robes you've been seeing around. But time is too short for that." },
    { who: "Samantha", text: "The research stations are part of a ritual. Thirty years old. It was going to end next week and summon an eldritch god into our dimension. A benevolent one." },
    { who: "Samantha", text: "Now the ritual is broken. We don't know what god is going to come through. And until it does, smaller things will slip through the cracks we've been making in reality." },
    { text: "As if to prove her point, a howl rises out of the dark. Then a second one." },
    { text: "They sound like wolves. They are not wolves. No wolf has a voice that deep, or that long, or that close to words." },
    { who: "Sam", text: "Mom. That's them. The ones from the stories." },
    { text: "Samantha throws the door wide. Robed figures pour in out of the snow. A dozen of them, red hoods pushed back, faces white with fear." },
    { who: "Samantha", text: "Listen to me. At the bottom of the cave, down the stairs, there is a key. It opens the sealed iron door in your basement." },
    { who: "Samantha", text: "Behind that door we can do another ritual. It might be the only thing that saves us." },
    { who: "Dana", text: "Might?" },
    { who: "Samantha", text: "Might." },
    { text: "Before anyone can move, the howling stops. The silence is worse." },
    { text: "Joe looks out the window. Something enormous is standing in the trees." },
  ],
};

export const WOLVES_END = {
  id: "living:event:wolves", room: "living", title: "The Wolves",
  text: "Two gigantic wolves came for the summoners. Most of the cult died in the snow. The wolves became two women, and the survivors followed them into the dark.",
  lines: [
    { text: "The snow outside is red. Bodies lie where they fell. The two women are gone, and so are the ones who followed them." },
    { who: "Chloe", text: "They always go with them. Nobody ever comes back." },
    { text: "Samantha pulls her children close. For the first time, she looks afraid." },
    { who: "Samantha", text: "Those two were Romulus and Remus. Minor eldritch deities. Very old, and very hungry." },
    { who: "Samantha", text: "The ones who walked out to them aren't my people anymore. They belong to the wolves now." },
    { who: "Stephen", text: "So we wait for daylight and—" },
    { who: "Samantha", text: "We can't wait. Every hour that door stays shut, the cracks get wider." },
    { who: "Samantha", text: "I need help getting the key from the bottom of the cave. Who's coming with me?" },
    { text: "Silence. Then Joe stands up." },
    { who: "Joe", text: "I'll go. I'm the one who broke it." },
    { who: "Dana", text: "...Me too. Somebody has to keep an eye on him." },
    { who: "Sarah", text: "Dana, no. Please. I can't. I can't go back down there." },
    { who: "Stephen", text: "I'll stay with Sarah. And the kids. I'm sorry. I'm not brave enough for this." },
    { who: "Samantha", text: "Then it's the three of us. There's a straight path to the cave behind the cabin. We go now." },
  ],
};

export const CH2_END = {
  id: "living:event:ch2end", room: "living", title: "Down the Iron Stairs",
  text: "Samantha said Joe wasn't trustworthy enough and sent him back to the children. Dana followed Samantha down the stairs behind the iron door.",
  lines: [
    { text: "Joe climbs back up out of the basement. Sam and Chloe are sitting by the fire, wrapped in one blanket." },
    { who: "Chloe", text: "Did Mom go down?" },
    { who: "Joe", text: "Yeah. With Dana." },
    { who: "Sam", text: "Then we wait. That's what we always do." },
    { text: "Joe sits with them and stares at the basement door. He doesn't touch the flask." },
    { text: "END OF CHAPTER TWO — THE DRUNKEN IDIOT" },
  ],
};

export const CH2_EVENTS = [CH2_MORNING, QUAKE, WAITING, KNOCK, WOLVES_END, CH2_END];
